import { withProfiler, wrapCreateBrowserRouter } from '@sentry/react';
import { QueryClient, QueryClientProvider, keepPreviousData } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { posthog } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import type { RoutesFunc } from 'src/routes/routes';

import './app.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      placeholderData: keepPreviousData,
    },
  },
});

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter) as typeof createBrowserRouter;

function App({ routes }: { routes: RoutesFunc }) {
  return (
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={sentryCreateBrowserRouter(routes(queryClient))} />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </PostHogProvider>
  );
}

export const ProfiledApp = withProfiler(App);
